<template>
	<div
		class="g-block-title-left-bar-bg g-block-title-padding"
		:class="{
			'g-block-title-left-bar-bg--edit': editable,
			'is-active': editable && active,
			'g-block-title-left-bar-bg--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-left-bar-bg__row">
			<span class="g-block-title-left-bar-bg__bar" :style="{ background: themeColor }"></span>
			<div class="g-block-title-left-bar-bg__strip" :style="{ background: stripBackground }">
				<RichTextEditable
					v-if="editable"
					class="g-block-title-left-bar-bg__text"
					fit-content
					:style="{ color: themeColor }"
					:model-value="data.content"
					placeholder="请输入标题"
					@update:model-value="onContentUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-title-left-bar-bg__text"
					:style="{ color: themeColor }"
					v-html="data.content || ''"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { singleTitleMixin } from '../shared/singleTitleMixin.js';
	import { lightenHexColor } from '../../../utils/richText.js';

	export default {
		name: 'GBlockTitleLeftBarBg',
		components: { RichTextEditable },
		mixins: [singleTitleMixin],
		computed: {
			stripBackground() {
				return lightenHexColor(this.themeColor, 0.93);
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../shared/titleEditShell.less';

	.g-block-title-left-bar-bg {
		.title-block-edit-shell();
	}

	.g-block-title-left-bar-bg__row {
		display: flex;
		align-items: stretch;
		gap: 0;
	}

	.g-block-title-left-bar-bg__bar {
		width: 4px;
		flex-shrink: 0;
		align-self: stretch;
	}

	.g-block-title-left-bar-bg__strip {
		flex: 1;
		min-width: 0;
		padding: 12px 16px 12px 14px;
	}

	.g-block-title-left-bar-bg__text {
		font-size: 18px;
		font-weight: 700;
		line-height: 1.3;
		:deep(.g-rich-text-editable__content) { min-height: unset; padding: 0; font-weight: 700; }
	}

	.g-block-title-left-bar-bg--h5 {
		.g-block-title-left-bar-bg__bar { width: 0.08rem; }
		.g-block-title-left-bar-bg__strip { padding: 0.24rem 0.32rem 0.24rem 0.28rem; }
		.g-block-title-left-bar-bg__text { font-size: 0.36rem; }
	}
</style>
